// extracted by mini-css-extract-plugin
export var brand = "_7n-8";
export var compact = "_7n-5";
export var extraSmall = "_7n-6";
export var icon = "_7n-0";
export var large = "_7n-3";
export var light = "_7n-1";
export var medium = "_7n-4";
export var outline = "_7n-a";
export var primaryDark = "_7n-9";
export var primaryLight = "_7n-7";
export var primaryModern = "_7n-b";
export var success = "_7n-2";